export const Colors = {
    white: "#fff",
    green: "rgb(136, 198, 86)",
    grey: "rgba(0,0,0,0.5)",
    "$success-500": "#1F8747",
    "$error-600": "#b8433c",
    "$theme-warning": "#D69F38",
    "$sapphire": "#0973BA",
};